module.exports = vendor_a6953362a7dafb14f847;


//////////////////
// WEBPACK FOOTER
// external "vendor_a6953362a7dafb14f847"
// module id = 20
// module chunks = 0